import { useState, useCallback, useEffect, useRef, useReducer } from 'react';
import log from 'app/home/general-components/Logging';

export const DeviceType = {
    doorSensor: 0,
    dpst: 1,
    depricatedEvaporativeCooler: 2,
    motion: 3,
    plug: 4,
    lamp: 5,
    sedna: 6,
    remote: 8,
    tvRemote: 9,
    splitRemote: 10,
    fanRemote: 11,
    siren: 13,
    homeTheatreRemote: 14,
    soundBarRemote: 15,
    receiverRemote: 16,
    projectorRemote: 17,
    lampX3: 18,
    lampX4: 19,
    marsus: 20,
    winep: 21, // not released
    tuyaRemote: 22,
    curtain: 23,
    scenarioSwitch: 24,
    relay4: 25,
    amplifier: 26,
    evaporativeCooler: 27,
    wifiDoorSensor: 28,
    hinavaEcoThermostat: 29,
    wifiMotionSensor: 30,
    multipurposeSensor: 31,
    wc: 32,
    elevator1: 33, // not in statechart
    doorbell: 34, // not in statechart
    curtain1Lamp2: 35,
    lampX1TwoWay: 36,
};

const StrDeviceType = {
    0: "door_sensor",
    1: "lamp2",
    // 2: depricatedEvaporativeCooler,
    3: "motion_sensor",
    4: "plug",
    5: "lamp1",
    6: "thermostat", // sedna
    8: "everymote",
    // tvRemote: 9,
    // splitRemote: 10,
    // fanRemote: 11,
    13: "siren",
    // homeTheatreRemote: 14,
    // soundBarRemote: 15,
    // receiverRemote: 16,
    // projectorRemote: 17,
    18: "lamp3",
    19: "lamp4",
    // 20: marsus,
    // 21: winep,
    // 22: tuyaRemote,
    23: "curtain2",
    24: "scenario",
    25: "relay4",
    26: "audio_controller",
    27: "cooler",
    28: "door_sensor",
    29: "thermostat",
    30: "motion_sensor",
    31: "multipurpose_sensor",
    32: "wc",
    33: "elevator_switch1",
    34: "doorbell_switch",
    35: "curtain1_lamp2",
    36: "lamp1_2way",
};

const IntDeviceTypeForSoloAddDevice = {
    // "door_sensor": 0, // ble
    "lamp2": 1,
    // "motion_sensor": 3, // ble
    "plug": 4,
    "lamp1": 5,
    // "thermostat": 6, // sedna
    "everymote": 8,
    "siren": 13,
    "lamp3": 18,
    "lamp4": 19,
    "curtain2": 23,
    "scenario": 24,
    "relay4": 25,
    "audio_controller": 26,
    "cooler": 27,
    "door_sensor": 28,
    "thermostat": 29,
    "motion_sensor": 30,
    "multipurpose_sensor": 31,
    "wc": 32,
    "elevator_switch1": 33,
    "doorbell_switch": 34,
    "curtain1_lamp2": 35,
    "lamp1_2way": 36,
};

export const WCScenario = {
    nothing: 0,
    in_use: 1,
    refresh: 2,
};

export const WifiDoorAndMotionSensorBatteryStatus = {
    notCharging: 0,
    charging: 1,
    noBatteryDetected: 2,
};

export const EvaporativeCoolerPower = {
    off: 0,
    on: 1,
    staring: 2,
};

export const AmplifierMode = {
    ble: 0,
    aux: 1,
    hinava: 2,
    hdmi: 3,
};

export const CurtainState = {
    idle: 0,
    open: 1,
    close: 2,
};

export const SednaInfo = {
    subType: {
        volkan: 0,
        eris: 1,
        vesta: 2,
    },
    mode: {
        cooling: 0,
        heating: 1,
    },
    motorSpeed: {
        auto: 0,
        low: 1,
        medium: 2,
        high: 3,
    },
    scenario: {
        manual: 0,
        away: 1,
        sleep: 2,
        turbo: 3,
    },
};

export const HinavaEcoThermostatInfo = {
    mode: {
        cooling: 0,
        heating: 1,
        fan: 2,
    },
    fanSetting: {
        auto: 0,
        low: 1,
        medium: 2,
        high: 3,
    },
    fanStatus: {
        off: 0,
        low: 1,
        medium: 2,
        high: 3,
    },
};

export const MarsusInfo = {
    subType: {
        fanCoil: 0,
        package: 1,
        cooler: 2,
    },
    fanCoil: {
        mode: {
            heat: 0,
            cool: 1,
        },
        fanSpeed: {
            fast: 3,
            medium: 2,
            slow: 1,
            auto: 7,
        },
    },
    package: {
        mode: {
            normal: 0,
            eco: 1,
            antiFreeze: 2,
        },
    },
    cooler: {
        mode: {
            manual: 0,
            auto: 1
        },
        fanSpeed: {
            fast: 2,
            medium: 1,
            off: 0,
        },
    },
};

export const SplitInfo = {
    mode: {
        auto: 0,
        cool: 1,
        dry: 2,
        heat: 3,
        fanOnly: 4,
    },
    fan: {
        auto: 0,
        x1: 1,
        x2: 2,
        x3: 3,
    },
    vSwing: {
        stop: 0,
        moving: 1,
        step1: 2,
        step2: 3,
        step3: 4,
        step4: 5,
    },
    hSwing: {
        stop: 0,
        moving: 1,
        step1: 2,
        step2: 3,
        step3: 4,
        step4: 5,
    },
};

export const DeviceColors = [
    [0, "#00ffdc"],
    [1, "#54c349"],
    [2, "#23f8ff"],
    [3, "#2386ff"],
    [4, "#9e54ff"],
    [5, "#ff1f8b"],
    [6, "#ff7ecb"],
    [7, "#ff2a00"],
    [8, "#ff5e00"],
    [9, "#fff700"],
    [10, "#ffffff"],
    [11, "#000000"]
]

export function getDeviceColorsRGB(colorId) {
    for (let i = 0; i < DeviceColors.length; i++) {
        const colorInfo = DeviceColors[i];
        if (colorInfo[0] === colorId) {
            return colorInfo[1];
        }
    }
    return undefined;
}

// function shuffle(a) {
//     for (let i = a.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [a[i], a[j]] = [a[j], a[i]];
//     }
//     return a;
// }

export function toStrDeviceType(list) {
    const _list = [];
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        const str = StrDeviceType[element];
        if (str !== undefined) {
            _list.push(str);
        }
    }
    return _list;
}

export function toIntDeviceTypeForSoloAddDevice(str) {
    return IntDeviceTypeForSoloAddDevice[str];
}

function applyChangeStateToDevices(devices, message, changeStateHandler, sendEvent) {
    let newDevices2 = devices.map((device) => {
        // propagate
        if ((device.sub_devices !== undefined) && Array.isArray(device.sub_devices)) {
            device.sub_devices = applyChangeStateToDevices(device.sub_devices, message, changeStateHandler, sendEvent)
        }

        // filter
        if (device.mac !== message.msg.mac)
            return device

        const finalDevice = { ...device };
        const notInstrestedKeys = ["mac", "type"]
        for (const key in message.msg) {
            if (!notInstrestedKeys.includes(key)) { // TODO: test & check protocol
                // if (device.hasOwnProperty(key) && !notInstrestedKeys.includes(key)) {
                finalDevice[key] = message.msg[key];
                if ((finalDevice.waitingForChangeState !== undefined) && (finalDevice.waitingForChangeState[key])) {
                    delete finalDevice.waitingForChangeState[key];
                }
                if (key === "sub_devices") {
                    fillSubDevicesFunctions(finalDevice, changeStateHandler, sendEvent);
                }
            }
        }

        // for audio controller
        const currentTimestamp = (new Date()).getTime();
        for (const key in message.msg) {
            if (key === "track_passed_time")
                finalDevice.trackPassedTimeLoadTimestamp = currentTimestamp;
        }
        return finalDevice;
    })

    return newDevices2;
}

function fillSubDevicesFunctions(device, changeStateHandler, sendEvent) {
    if ((device.sub_devices !== undefined) && Array.isArray(device.sub_devices)) {
        device.sub_devices = device.sub_devices.map((subDevice) => {
            return {
                ...subDevice,
                changeState: ((values) => {
                    return changeStateHandler.current(subDevice.mac, subDevice.type, values)
                }),
                rename: ((newName) => {
                    sendEvent('change_device_name', {
                        mac: subDevice.mac,
                        new_name: newName,
                    });
                }),
                remove: (() => {
                    sendEvent('remove_device', {
                        mac: subDevice.mac,
                    });
                }),
            }
        })
    }
}

const halfOfMaxWaitingForChangeState = 1; //sec

export const SyncSettingsMode = {
    none: 0,
    main: 1,
    follower: 2,
}

export default function useDeviceList(sendEvent, currentUser, rooms) {
    const changeStateHandler = useRef(undefined);
    const [needsCheckWaitingForChangeState, setNeedsCheckWaitingForChangeState] = useState(false);

    const deviceEventReducer = useCallback((currentDevices, event) => {
        const currentTimestamp = (new Date()).getTime();

        // console.log("deviceEventReducer event", event);

        switch (event.source) {
            case "RoomsUpdated":
                return currentDevices.map((device) => {
                    let roomName = getRoomNameOfTheDevice(event.inner, device.mac);
                    // console.log("getRoomNameOfTheDevice(", device.mac, ")", roomName);
                    let d = { ...device };
                    d.roomName = roomName;
                    return d;
                });
            case "UserChangeState":
                return currentDevices.map((device) => {
                    let innerEvent = event.inner;
                    if (device.mac === innerEvent.mac) {
                        const finalDevice = { ...device };
                        const notInstrestedKeys = ["mac", "type", "function"]
                        for (const key in innerEvent.values) {
                            // if (device.hasOwnProperty(key) && !notInstrestedKeys.includes(key)) {
                            if (Object.prototype.hasOwnProperty.call(device, key) && !notInstrestedKeys.includes(key)) {
                                finalDevice[key] = innerEvent.values[key];

                                // if (!finalDevice.waitingForChangeState.hasOwnProperty(key)) {
                                if (!Object.prototype.hasOwnProperty.call(finalDevice.waitingForChangeState, key)) {
                                    let now = new Date();
                                    now.setSeconds(now.getSeconds() + halfOfMaxWaitingForChangeState);
                                    finalDevice.waitingForChangeState[key] = {
                                        time: now.getTime(),
                                        ignoreWaiting: true,
                                    }
                                    setNeedsCheckWaitingForChangeState(true);
                                }
                            }
                        }

                        // for audio controller
                        for (const key in innerEvent.values) {
                            if (key === "track_passed_time")
                                finalDevice.trackPassedTimeLoadTimestamp = currentTimestamp;
                        }
                        return finalDevice;
                    }
                    return device;
                })
            case "ChangeStateCheck":
                // console.log("new check");
                let now = (new Date()).getTime();
                let totallyChanged = false;
                let needsAnotherWaiting = false;
                let newDevices = currentDevices.map((device) => {
                    const finalDevice = { ...device };
                    let changed = false;
                    for (const key in finalDevice.waitingForChangeState) {
                        if (now >= finalDevice.waitingForChangeState[key].time) {
                            if (finalDevice.waitingForChangeState[key].ignoreWaiting !== false) {
                                finalDevice.waitingForChangeState[key].ignoreWaiting = false;
                                changed = true;
                            }
                        } else {
                            needsAnotherWaiting = true;
                        }
                    }
                    if (changed) {
                        totallyChanged = true;
                        return finalDevice;
                    } else {
                        return device;
                    }
                })

                setNeedsCheckWaitingForChangeState(needsAnotherWaiting);

                if (totallyChanged)
                    return newDevices;
                else
                    return currentDevices;
            case "Gateway":
                let { message, rooms } = event.inner;
                switch (message.ev) {
                    case 'device_list':
                        // setUpdateStatus('stable');
                        return message.msg.devices.map((device) => {
                            const newDevice = {
                                ...device,
                                waitingForChangeState: {},
                                changeState: ((values) => { // will check permission inside changeStateHandler
                                    return changeStateHandler.current(device.mac, device.type, values)
                                }),
                                // forcedChangeState: ((values) => {
                                //     sendEvent('forced_change_state', {
                                //         mac: device.mac,
                                //         type: device.type,
                                //         ...values
                                //     });
                                // }),
                                // active: false,
                                rename: ((newName) => {
                                    sendEvent('change_device_name', {
                                        mac: device.mac,
                                        new_name: newName,
                                    });
                                }),
                                remove: (() => {
                                    sendEvent('remove_device', {
                                        mac: device.mac,
                                    });
                                }),
                                indicate: (() => {
                                    sendEvent('indicate_device', {
                                        mac: device.mac,
                                    });
                                }),
                                startOTA: ((otaID) => {
                                    sendEvent('start_ota', {
                                        mac: device.mac,
                                        ota_id: otaID,
                                    });
                                }),
                                roomName: getRoomNameOfTheDevice(rooms, device.mac),

                                // for audio controller
                                trackPassedTimeLoadTimestamp: currentTimestamp,
                                setTrackList: (({ listType, listName, listPath }) => {
                                    sendEvent('set_track_list', {
                                        mac: device.mac,
                                        list_type: listType,
                                        list_name: listName,
                                        list_path: listPath,
                                    });
                                }),
                            };
                            fillSubDevicesFunctions(newDevice, changeStateHandler, sendEvent);
                            return newDevice;
                        });
                    case 'change_state':
                        return applyChangeStateToDevices(currentDevices, message, changeStateHandler, sendEvent);
                    case 'change_power':
                        return currentDevices.map((device) => {
                            if (device.mac !== message.msg.mac)
                                return device

                            const finalDevice = { ...device };
                            finalDevice["power"] = message.msg["power"];
                            return finalDevice;
                        })
                    default:
                        log('unsupported event in useDeviceList,', message.ev);
                        break;
                }
                break
            default:
                log('unsupported event in deviceEventReducer,', event);
                break;
        }
    }, [sendEvent]);
    // }, [sendEvent, setUpdateStatus]);

    const [devices, dispatchDeviceEvent] = useReducer(deviceEventReducer, []);

    useEffect(() => {
        changeStateHandler.current = (mac, type, values) => {
            if (currentUser.permissions.device.change_state) {
                dispatchDeviceEvent({ source: "UserChangeState", inner: { mac, type, values } });

                sendEvent('change_state', {
                    mac: mac,
                    type: type,
                    ...values
                });
            }
        }
    }, [sendEvent, currentUser]);

    useEffect(() => {
        if (needsCheckWaitingForChangeState) {
            dispatchDeviceEvent({ source: "ChangeStateCheck" });
            let t = setInterval(() => {
                dispatchDeviceEvent({ source: "ChangeStateCheck" });
            }, halfOfMaxWaitingForChangeState * 1000);
            return () => {
                clearInterval(t);
            }
        }
    }, [needsCheckWaitingForChangeState]);

    const setDeviceFolowers = useCallback((mainMac, mainType, syncSettings) => {
        // if (currentUser.permissions.device.) { ستینگ ... ولی قبلا چک شده
        // dispatchDeviceEvent({ source: "SyncSettingsUpdated", inner: { mainMac, syncSettings } });

        sendEvent('change_state', {
            mac: mainMac,
            type: mainType,
            "sync_settings": syncSettings
        });
        // }
    }, [sendEvent]);

    const onDeviceRelatedEvent = useCallback((message) => {
        dispatchDeviceEvent({ source: "Gateway", inner: { message, rooms } });
    }, [rooms])

    useEffect(() => {
        dispatchDeviceEvent({ source: "RoomsUpdated", inner: rooms });
    }, [rooms]);

    return [devices, setDeviceFolowers, onDeviceRelatedEvent]
}

function getRoomNameOfTheDevice(rooms, deviceMac) {
    for (const roomId in rooms) {
        const room = rooms[roomId];
        if (room["device_macs"].includes(deviceMac)) {
            return room["name"];
        }
    }
    return undefined;
}

export function useDeviceStub({
    name, mac, type, sub_type, num_channels, config_per_mode,
    use_custom_switch_names, switch1_name, switch2_name, switch3_name, switch4_name,
    set_point_min, set_point_max, has_fan_mode }) {
    const [states, setStates] = useState({}); // will embed in protocol's messages
    const [additionalStates, setAdditionalStates] = useState({}); // read only, only for additional info

    useEffect(() => {
        switch (type) {
            case DeviceType.plug:
                setStates({ "state": false });
                break;
            case DeviceType.lamp:
            case DeviceType.lampX1TwoWay:
                setStates({
                    "state": false,
                });
                setAdditionalStates({
                    "use_custom_switch_names": use_custom_switch_names,
                    "switch1_name": switch1_name
                });
                break;
            case DeviceType.dpst:
                setStates({
                    "state1": false, "state2": false,
                });
                setAdditionalStates({
                    "use_custom_switch_names": use_custom_switch_names,
                    "switch1_name": switch1_name,
                    "switch2_name": switch2_name
                });
                break;
            case DeviceType.lampX3:
                setStates({
                    "state1": false, "state2": false, "state3": false,
                });
                setAdditionalStates({
                    "use_custom_switch_names": use_custom_switch_names,
                    "switch1_name": switch1_name,
                    "switch2_name": switch2_name,
                    "switch3_name": switch3_name
                });
                break;
            case DeviceType.evaporativeCooler:
                setStates({ "power": false, "pump": false, "slow_fan": false, "fast_fan": false });
                break;
            case DeviceType.wc:
                setStates({ "lamp": false, "fan": false, "spray": false, "music": false, "scenario": WCScenario.nothing });
                break;
            case DeviceType.lampX4:
            case DeviceType.winep:
                setStates({
                    "state1": false, "state2": false, "state3": false, "state4": false,
                });
                setAdditionalStates({
                    "use_custom_switch_names": use_custom_switch_names,
                    "switch1_name": switch1_name,
                    "switch2_name": switch2_name,
                    "switch3_name": switch3_name,
                    "switch4_name": switch4_name
                });
                break;
            case DeviceType.curtain1Lamp2:
                setStates({
                    "lamp1": false, "lamp2": false,
                    "curtain": CurtainState.idle
                });
                setAdditionalStates({
                    "use_custom_switch_names": use_custom_switch_names,
                    "switch1_name": switch1_name,
                    "switch2_name": switch2_name,
                });
                break;
            case DeviceType.relay4:
                setStates({
                    "channel1": false, "channel2": false, "channel3": false, "channel4": false,
                });
                setAdditionalStates({
                    "use_custom_switch_names": use_custom_switch_names,
                    "switch1_name": switch1_name,
                    "switch2_name": switch2_name,
                    "switch3_name": switch3_name,
                    "switch4_name": switch4_name
                });
                break;
            case DeviceType.curtain:
                setAdditionalStates({ "num_channels": num_channels });
                if (num_channels === 1) {
                    setStates({ "channel1": CurtainState.idle });
                } else if (num_channels === 2) {
                    setStates({ "channel1": CurtainState.idle, "channel2": CurtainState.idle });
                }
                break;
            case DeviceType.siren:
                setStates({ "state": false });
                break;
            case DeviceType.doorbell:
                setStates({ "state": false });
                break;
            case DeviceType.elevator1:
                setStates({ "state1": false });
                break;
            case DeviceType.marsus:
                switch (sub_type) {
                    case MarsusInfo.subType.fanCoil:
                        setStates({
                            "is_on": true,
                            "mode": MarsusInfo.fanCoil.mode.heat,
                            "fan_speed": MarsusInfo.fanCoil.fanSpeed.auto,
                            "set_point": 25
                        });
                        setAdditionalStates({
                            "temperature": 25,
                        })
                        break;
                    case MarsusInfo.subType.package:
                    case MarsusInfo.subType.cooler:
                    default:
                        return null;
                }
                break;
            case DeviceType.splitRemote:
                let splitModes = Object.keys(config_per_mode);
                splitModes.sort();
                let splitConf = config_per_mode[splitModes[0]];
                let splitState = { "mode": parseInt(splitModes[0]), "is_on": true };
                setAdditionalStates({ "config_per_mode": config_per_mode });
                if (splitConf["set_point_enable"]) {
                    splitState["set_point"] = Math.floor((splitConf["min_set_point"] + splitConf["max_set_point"]) / 2);
                } else {
                    splitState["set_point"] = undefined;
                }
                if (splitConf["fan_enable"]) {
                    splitState["fan"] = splitConf["fan_values"][0];
                } else {
                    splitState["fan"] = undefined;
                }
                setStates(splitState);
                break;
            case DeviceType.sedna:
                switch (sub_type) {
                    case SednaInfo.subType.volkan:
                        setStates({
                            "is_on": true,
                            "mode": SednaInfo.mode.heating,
                            "set_point": 23,
                            "motor_speed": SednaInfo.motorSpeed.low,
                            "scenario": SednaInfo.scenario.manual,
                        });
                        setAdditionalStates({
                            "temperature": 25,

                            "scenario_enable": true,
                            "motor_speed_enable": true,
                            "set_point_enable": true,
                            "mode_enable": true,
                            "set_point_min": set_point_min,
                            "set_point_max": set_point_max
                        })
                        break;
                    case SednaInfo.subType.eris:
                    case SednaInfo.subType.vesta:
                    default:
                        break;
                }
                break;
            case DeviceType.hinavaEcoThermostat:
                setStates({
                    "is_on": true,
                    "mode_setting": HinavaEcoThermostatInfo.mode.heating,
                    "set_point": 23,
                    "fan_setting": HinavaEcoThermostatInfo.fanSetting.low,
                    "turbo_setting": false,
                });
                setAdditionalStates({
                    "temperature": 25,
                    "has_fan_mode": has_fan_mode,
                    "set_point_min": set_point_min,
                    "set_point_max": set_point_max
                })
                break;
            default:
                break;
        }
    }, [type, sub_type, config_per_mode, num_channels,
        use_custom_switch_names, switch1_name, switch2_name, switch3_name, switch4_name,
        set_point_max, set_point_min, has_fan_mode]);

    const changeState = useCallback((changeStateObject) => {
        let newStates = { ...states };
        let newAdditionalStates = { ...additionalStates };
        for (const key in changeStateObject) {
            // if (newStates.hasOwnProperty(key) && changeStateObject.hasOwnProperty(key)) {
            if (Object.prototype.hasOwnProperty.call(newStates, key) &&
                Object.prototype.hasOwnProperty.call(changeStateObject, key)) {
                newStates[key] = changeStateObject[key];
            }
        }

        if ((type === DeviceType.hinavaEcoThermostat)) {
            // turbo is on
            if (newStates["turbo_setting"] === true) {
                if (changeStateObject["turbo_setting"] === true) {
                    // wanted to turn torbo on
                    newStates["fan_setting"] = HinavaEcoThermostatInfo.fanSetting.auto;
                } else if (
                    (changeStateObject["fan_setting"] === HinavaEcoThermostatInfo.fanSetting.low) ||
                    (changeStateObject["fan_setting"] === HinavaEcoThermostatInfo.fanSetting.medium) ||
                    (changeStateObject["fan_setting"] === HinavaEcoThermostatInfo.fanSetting.high)
                ) {
                    // cancel turbo
                    newStates["turbo_setting"] = false;
                }
            }
            // fix fan_status
            // newAdditionalStates["fan_status"] = newStates["fan_setting"];
        }

        if ((changeStateObject["function"] !== undefined) && (type === DeviceType.splitRemote)) {
            let splitConf = config_per_mode[String(newStates["mode"])];
            let modes = Object.keys(config_per_mode);
            modes.sort();
            switch (changeStateObject["function"]) {
                case 0: // on/off
                    newStates["is_on"] = !newStates["is_on"];
                    break;
                case 1: // temp up
                    newStates["set_point"] = Math.min(splitConf["max_set_point"], newStates["set_point"] + 1);
                    break;
                case 2: // temp down
                    newStates["set_point"] = Math.max(splitConf["min_set_point"], newStates["set_point"] - 1);
                    break;
                case 6: // speed
                    newStates["fan"] = splitConf["fan_values"][(splitConf["fan_values"].indexOf(newStates["fan"]) + 1) % splitConf["fan_values"].length];
                    break;
                case 5: // mode
                    newStates["mode"] = parseInt(modes[(modes.indexOf(String(newStates["mode"])) + 1) % modes.length]);
                    splitConf = config_per_mode[String(newStates["mode"])];
                    if (splitConf["set_point_enable"]) {
                        newStates["set_point"] = Math.floor((splitConf["min_set_point"] + splitConf["max_set_point"]) / 2);
                    } else {
                        newStates["set_point"] = undefined;
                    }
                    if (splitConf["fan_enable"]) {
                        newStates["fan"] = splitConf["fan_values"][0];
                    } else {
                        newStates["fan"] = undefined;
                    }
                    break;
                default:
                    break;
            }
        }
        setStates(newStates);
        setAdditionalStates(newAdditionalStates);
    }, [states, additionalStates, config_per_mode, type]);

    return [
        // for UI
        {
            ...states, mac, type, sub_type, name,
            ...additionalStates, waitingForChangeState: {}, changeState, active: true
        },
        // for protocol
        { ...states, mac, type, sub_type }
    ];
}